import React, { Fragment } from "react";
import * as style from "./styles.module.scss";

const SelectableOptionGroup = ({
  selectedOption,
  handleOptionChange,
  options = [],
  name = "selectableOptionGroup",
  multiple = false,
  validationMessages = [],
  disabled = false,
}) => {
  const isInvalid = validationMessages.length > 0;
  const validationMessage = isInvalid ? validationMessages[0] : "";
  const borderColor = isInvalid ? { borderColor: "red" } : {};

  return (
    <Fragment>
      <div className={style.optionsGroup}>
        {options.map((option) => {
          const { value, label } = option;
          return (
            <label
              key={value}
              className={`${style.optionContainer} ${
                selectedOption === value
                  ? `${style.optionContainer__selected}`
                  : ""
              }`}
              style={{ ...borderColor }}
            >
              <input
                type={multiple ? "checkbox" : "radio"}
                name={name}
                value={value}
                checked={
                  multiple
                    ? selectedOption.includes(value)
                    : selectedOption === value
                }
                onChange={handleOptionChange}
                disabled={disabled}
              />
              <span className={style.optionContainer__customOption} />
              <span className={style.labelText}>{label}</span>
            </label>
          );
        })}
      </div>
      {validationMessage && (
        <span className="text_invalid fontSize-12" style={{ color: "red" }}>
          {validationMessage}
        </span>
      )}
    </Fragment>
  );
};

export default SelectableOptionGroup;
